import DevicePay from './DevicePay'

export default DevicePay
